/* tslint:disable:align */
//============================================================================
// Name        : pin_authentication.ts
// Purpose     : Implement PIN authentication
// Created     : 2019-12-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { AxiosResponse } from "axios";

interface IPinLoginResponse {
    success: boolean;
    message: string;
}

export default class PinAuthentication {
    constructor() {
        $("#pin-auth-dialog #pin-auth-login").on("click", this.authenticatePinUser);
        $("#pin-auth-dialog #pin-auth-cancel").on("click", this.hidePinLogin);
    }

    showPinLogin(): void {
        $("#pin-auth-dialog").modal("show");
        setTimeout(() => {
            $("#pin-auth-dialog #pin_field").focus();
        }, 1250);
    }

    hidePinLogin(): void {
        $("#pin-auth-dialog").modal("hide");
    }

    async authenticatePinUser() {
        const loginUrl = $("#pin-auth-dialog #login_url").val() as string;
        const data = {
            pin: $("#pin-auth-dialog #pin_field").val(),
            authenticity_token: $('meta[name="csrf-token"]').attr("content")
        };

        const resp: AxiosResponse<IPinLoginResponse> = await axios.post(loginUrl, data);
        if (resp.status >= 400 || resp.data.success == false) {
            window.PinAuthentication.showAuthError(resp.data.message);
            return;
        }
        window.PinAuthentication.redirectAfterAuth();
    }

    setRedirectAfterAuthUrl(url: string): void {
        $("#pin-auth-dialog #redirect_url").val(url);
    }

    redirectAfterAuth = (): void => {
        const redirectTo = $("#pin-auth-dialog #redirect_url").val() as string;
        const deleteItem = $("#delete-item").val() as string;
        if (deleteItem == "true") {
            $.ajax({
                type: "DELETE",
                url: redirectTo,
                success: (response) => {
                    window.location.reload();
                }
            });
        } else {
            location.href = redirectTo;
        }

    }

    showAuthError(msg: string): void {
        window.showErrorDialog(msg);
    }
}

// Add our new PinAuthentication class to the window object
declare global {
    // tslint:disable-next-line: interface-name
    interface Window {
        PinAuthentication: PinAuthentication;
        showErrorDialog: (msg: string) => void;
        showInfoDialog: (msg: string) => void;
    }
}

window.PinAuthentication = new PinAuthentication();
